import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lobDescription',
})
export class LobDescriptionPipe implements PipeTransform {
  transform(lob: string, type: string, line: string): string {
    if (!lob) {
      return lob;
    }

    let lobDesc: string;
    let typeDesc = '';
    switch (lob) {
      case 'WC':
        lobDesc = "Workers' Compensation";
        typeDesc =
          type === 'IO'
            ? 'Incident Only'
            : type === 'IN'
              ? 'Indemnity'
              : type === 'MO'
                ? 'Medical Only'
                : type === 'EL'
                  ? "Employer's Liability"
                  : '';
        break;
      case 'DS':
        lobDesc = line !== 'AC' ? 'Disability' : 'Accommodations';
        typeDesc =
          type === 'SD'
            ? 'Short Term'
            : type === 'LD'
              ? 'Long Term'
              : type === 'SU'
                ? 'Supplemental'
                : type === 'VP'
                  ? 'Voluntary Plan'
                  : type === 'PL'
                    ? 'Paid Leave'
                    : '';
        break;
      case 'AU':
        lobDesc = 'Auto Liability';
        typeDesc = this.toTitleCase(type);
        break;
      case 'LA':
        lobDesc = 'Leave of Absence';
        typeDesc = type;
        // type === '60'
        //   ? 'Bereavement'
        //   : type === '26'
        //   ? 'Donate Bone Marrow'
        //   : type === '31'
        //   ? 'Domestic Violence'
        //   : type === '38'
        //   ? 'Emergency Services'
        //   : type === '33'
        //   ? 'Employee Medical'
        //   : type === '35'
        //   ? 'Family Leave'
        //   : type === '64'
        //   ? 'Jury Duty'
        //   : type === '41'
        //   ? 'Military'
        //   : type === '63'
        //   ? 'Organ Donation'
        //   : type === '47'
        //   ? 'School Activities'
        //   : type === '49'
        //   ? 'Sick Child'
        //   : type === '54'
        //   ? 'Victim of Crime'
        //   : '';

        break;
      case 'PR':
        lobDesc = 'Property';
        typeDesc = type;
        break;
      case 'PL':
        lobDesc = 'Professional Liability';
        typeDesc = type;
        break;
      case 'GL':
        lobDesc = 'General Liability';
        typeDesc = this.toTitleCase(type);
        break;
      case 'AD':
        lobDesc = 'Accommodation Request';
        typeDesc = type;
        break;
      default:
        lobDesc = 'Claim';
        break;
    }

    if (typeDesc) {
      return `${lobDesc} - ${typeDesc}`;
    } else {
      return lobDesc;
    }
  }

  private toTitleCase(value: string): string {
    if (!value) return value;
    return value
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
